(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1469],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 52143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CompanyLinks; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97749);
/* harmony import */ var _components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53300);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var CompanyLinks = function CompanyLinks(_ref) {
  var padding = _ref.padding;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviListWrapper, {
    padding: padding,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviList, {
      children: _utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_ROUTE.subdirectories.map */ .Ir.subdirectories.map(function (_ref2) {
        var path = _ref2.path,
            name = _ref2.name,
            imagePath = _ref2.imagePath;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__/* .LinkCard */ .k, {
            link: path,
            title: name,
            imgPath: imagePath
          })
        }, name);
      })
    })
  });
};
var CompanyNaviListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CompanyLinks__CompanyNaviListWrapper",
  componentId: "sc-106wc0z-0"
})(["margin:0 auto;padding:", ";width:1040px;@media screen and (max-width:1047px){padding:", ";width:100%;display:", ";}"], function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding.sp;
}, function (_ref5) {
  var padding = _ref5.padding;
  return !padding.sp && 'none';
});
var CompanyNaviList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "CompanyLinks__CompanyNaviList",
  componentId: "sc-106wc0z-1"
})(["display:flex;flex-wrap:wrap;gap:66px 46px;@media screen and (max-width:1047px){justify-content:center;gap:38px;li:nth-child(odd):last-child{margin-right:388px;}}@media screen and (max-width:700px){li:nth-child(odd):last-child{margin-right:0;}}"]);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 85132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ PhilosophyPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Company/Philosophy/ExplanationItem.tsx




var ExplanationItem = function ExplanationItem(_ref) {
  var mainTitle = _ref.mainTitle,
      subTitle = _ref.subTitle,
      text = _ref.text;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ExplanationItemStyled, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
      children: [mainTitle, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: subTitle
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: text
    })]
  });
};
var ExplanationItemStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExplanationItem__ExplanationItemStyled",
  componentId: "sc-1ghsxq4-0"
})(["h4{font-size:25px;color:", ";font-weight:bold;font-family:", ";line-height:1;margin-bottom:10px;}span{margin-left:16px;font-size:20px;color:#3786c7;font-weight:normal;}p{font-size:18px;line-height:1.5;}& + &{margin-top:40px;}@media screen and (max-width:1047px){h4{font-size:20px;margin-bottom:8px;}span{font-size:18px;}p{font-size:15px;}& + &{margin-top:26px;}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.fontEn */.r.fontEn);
;// CONCATENATED MODULE: ./src/components/pages/Company/Philosophy/TalkList.tsx



var TalkList = function TalkList(_ref) {
  var talkTitle = _ref.talkTitle,
      talkList = _ref.talkList;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TalkListStyled, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TalkTitle, {
      children: talkTitle
    }), talkList.map(function (_ref2) {
      var id = _ref2.id,
          nameColor = _ref2.nameColor,
          name = _ref2.name,
          talkContent = _ref2.talkContent;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TalkContent, {
        color: nameColor,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: [name, "\uFF1A"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: talkContent
        })]
      }, id);
    })]
  });
};
var TalkListStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TalkList__TalkListStyled",
  componentId: "sc-1z060ea-0"
})(["padding-bottom:90px;&:last-child{padding-bottom:0;}@media screen and (max-width:1047px){padding-bottom:46px;}"]);
var TalkTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "TalkList__TalkTitle",
  componentId: "sc-1z060ea-1"
})(["font-weight:bold;font-size:26px;border-bottom:1px solid #c0c0c0;padding-bottom:20px;position:relative;@media screen and (max-width:1047px){font-size:20px;padding-bottom:12px;&::after{top:44%;}}"]);
var TalkContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TalkList__TalkContent",
  componentId: "sc-1z060ea-2"
})(["display:flex;gap:15px;padding-top:40px;p{font-size:18px;line-height:1.8;}p:nth-of-type(1){color:", ";white-space:nowrap;font-weight:bold;}@media screen and (max-width:1047px){padding-top:24px;gap:5px;p{font-size:14px;}}"], function (_ref3) {
  var color = _ref3.color;
  return color;
});
;// CONCATENATED MODULE: ./src/components/pages/Company/Philosophy/talkLists.tsx



var talkItemList = [{
  talkTitle: '策定のきっかけ',
  talkList: [{
    id: '1',
    nameColor: '#002D65',
    name: '永田',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u5275\u696D40\u5468\u5E74\u3092\u8FCE\u3048\u3066\u3001\u6B21\u306E\u30B9\u30C6\u30FC\u30B8\u3078\u6E96\u5099\u3092\u6574\u3048\u3066\u3044\u307E\u3059\u3002\u65B0\u305F\u306A\u30B9\u30C6\u30FC\u30B8\u306B\u5411\u3051\u3066\u5168\u54E1\u304C\u6311\u6226\u3067\u304D\u308B\u3088\u3046\u306B\u3001\u5171\u901A\u8A00\u8A9E\u3092\u5B9A\u3081\u3066\u7406\u89E3\u6D78\u900F\u3092\u56F3\u308A\u305F\u3044\u3068\u601D\u3063\u305F\u3053\u3068\u304C\u304D\u3063\u304B\u3051\u3067\u3059\u3002"
    })
  }]
}, {
  talkTitle: '策定のための議論を振り返って',
  talkList: [{
    id: '1',
    nameColor: '#3786c7',
    name: '石橋',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u6642\u4EE3\u3068\u5171\u306B\u300C\u5909\u3048\u308B\u3079\u304D\u3082\u306E\u300D\u3068\u3001\u5275\u696D\u306E\u7406\u5FF5\u3068\u3057\u3066\u300C\u5909\u3048\u3066\u306F\u306A\u3089\u306A\u3044\u3082\u306E\u300D\u304C\u3042\u308A\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u8A00\u8449\u9078\u3073\u3082\u3053\u3060\u308F\u308A\u307E\u3057\u305F\u304C\u3001\u300C\u5909\u3048\u308B\u3082\u306E\u300D\u3068\u672C\u8CEA\u7684\u306B\u300C\u5909\u3048\u3066\u306F\u306A\u3089\u306A\u3044\u3082\u306E\u300D\u306E\u62BD\u51FA\u306F\u3001\u6642\u9593\u3092\u304B\u3051\u3066\u8B70\u8AD6\u3057\u307E\u3057\u305F\u3002"]
    })
  }]
}, {
  talkTitle: '言葉に込めた思い',
  talkList: [{
    id: '1',
    nameColor: '#002D65',
    name: '永田',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u305D\u308C\u305E\u308C\u306B\u30AD\u30FC\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u8FBC\u3081\u3066\u3044\u307E\u3059\u3002\u4F8B\u3048\u3070\u30D1\u30FC\u30D1\u30B9\u306B\u3042\u308B\u300C\u4E16\u754C\u4E2D\u306E\u8AB0\u3082\u304C\u8C4A\u304B\u3055\u3092\u4EAB\u53D7\u3067\u304D\u308B\u300D\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u81EA\u793E\u3060\u3051\u304C\u30E1\u30EA\u30C3\u30C8\u3092\u4EAB\u53D7\u3059\u308B\u306E\u3067\u306F\u306A\u304F\u3001\u79C1\u305F\u3061\u304C\u52AA\u529B\u3092\u3059\u308B\u3053\u3068\u3067\u793E\u4F1A\u306B\u826F\u3044\u5F71\u97FF\u3092\u53CA\u307C\u3057\u3066\u3001\u3072\u3044\u3066\u306F\u4E16\u754C\u306B\u8C4A\u304B\u3055\u3092\u5275\u51FA\u3059\u308B\u3053\u3068\u304C\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u5B58\u5728\u610F\u7FA9\u3067\u3042\u308A\u307E\u3059\u3002"]
    })
  }]
}, {
  talkTitle: 'こだわりのポイント',
  talkList: [{
    id: '1',
    nameColor: '#3786c7',
    name: '石橋',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u300CPractical savvy\uFF08\u4EBA\u306E\u7D4C\u9A13\u77E5\uFF09\u300D\u3068\u3044\u3046\u8A00\u8449\u306B\u3053\u3060\u308F\u308A\u307E\u3057\u305F\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u7279\u5FB4\u3092\u30D3\u30B8\u30E7\u30F3\u306B\u8868\u73FE\u3059\u308B\u969B\u3001\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3060\u3051\u3067\u306A\u304F\u3001\u4EBA\u306E\u300C\u7D4C\u9A13\u77E5\u300D\u3092\u5927\u5207\u306B\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u30E1\u30C3\u30BB\u30FC\u30B8\u3068\u3057\u3066\u8FBC\u3081\u307E\u3057\u305F\u3002\u305D\u308C\u3092\u65E5\u672C\u8A9E\u3068\u82F1\u8A9E\u3067\u8868\u73FE\u3067\u304D\u308B\u3088\u3046\u306B\u3001\u5DE5\u592B\u3057\u307E\u3057\u305F\u3002"]
    })
  }, {
    id: '2',
    nameColor: '#002D65',
    name: '永田',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u300C\u7D4C\u9A13\u77E5\u300D\u306F\u5F53\u793E\u306E\u7279\u5FB4\u3092\u8868\u3057\u3066\u3044\u308B\u8A00\u8449\u3067\u3059\u3002\u300C\u77E5\u300D\u3068\u3044\u3046\u6F22\u5B57\u3092\u4F7F\u3063\u3066\u3044\u308B\u7406\u7531\u306F\u3001\u4EBA\u304C\u305F\u304F\u3055\u3093\u306E\u6311\u6226\u304B\u3089\u5F97\u305F\u5B66\u3073\u3092\u3001\u4F1A\u793E\u306E\u6210\u9577\u306B\u7E4B\u3052\u308B\u3053\u3068\u3092\u5927\u5207\u306B\u3057\u3066\u304D\u305F\u304B\u3089\u3067\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u6642\u4EE3\u306B\u5408\u3046\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u53D6\u308A\u5165\u308C\u306A\u304C\u3089\u3001\u6050\u308C\u305A\u306B\u6311\u6226\u3057\u3066\u3044\u304F\u3068\u3044\u3046\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u8FBC\u3081\u3066\u3044\u307E\u3059\u3002"]
    })
  }]
}, {
  talkTitle: 'どう経営に活かしていくか',
  talkList: [{
    id: '1',
    nameColor: '#002D65',
    name: '永田',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u5168\u54E1\u304C\u30D1\u30FC\u30D1\u30B9\u30FB\u30D3\u30B8\u30E7\u30F3\u30FB\u30D0\u30EA\u30E5\u30FC\u306E\u91CD\u8981\u6027\u3092\u7406\u89E3\u3057\u305F\u4E0A\u3067\u3001\u884C\u52D5\u3059\u308B\u3053\u3068\u304C\u91CD\u8981\u3067\u3059\u3002\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u5E97\u8217\u304C\u91CD\u8996\u3059\u308B\u304A\u5BA2\u69D8\u8996\u70B9\u306B\u7ACB\u3063\u305F\u4FA1\u5024\u63D0\u6848\u306B\u3001\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u304C\u639B\u3051\u5408\u308F\u3055\u308B\u3053\u3068\u3067\u3001\u305D\u308C\u304C\u5B9F\u73FE\u3067\u304D\u308B\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u6D41\u901A\u4E8B\u696D\u3068\u30EA\u30C6\u30FC\u30EBAI\u4E8B\u696D\u306F\u30D3\u30B8\u30CD\u30B9\u306E\u4E2D\u8EAB\u306F\u9055\u3044\u307E\u3059\u304C\u3001\u76EE\u7684\u5730\u306F\u540C\u3058\u3067\u3059\u3002\u30B0\u30EB\u30FC\u30D7\u306E\u4E8B\u696D\u304C\u7E4B\u304C\u308B\u3053\u3068\u3067\u3001\u30D3\u30B8\u30E7\u30F3\u306E\u9054\u6210\u3084\u30D0\u30EA\u30E5\u30FC\u306E\u5B9F\u73FE\u304C\u3067\u304D\u307E\u3059\u3002"]
    })
  }, {
    id: '2',
    nameColor: '#3786c7',
    name: '石橋',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u591A\u304F\u306E\u304A\u5BA2\u69D8\u306B\u8CA2\u732E\u3059\u308B\u3088\u3046\u3001\u6D3B\u304B\u3057\u3066\u3044\u304D\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u6D41\u901A\u4E8B\u696D\u306F\u65E5\u3005\u306E\u73FE\u5834\u3067\u8D77\u304D\u3066\u3044\u308B\u3053\u3068\u304C\u3001\u672A\u6765\u3092\u5275\u308B\u767A\u60F3\u306E\u8D77\u70B9\u3067\u3059\u3002\u5168\u54E1\u306E\u300C\u6C17\u3065\u304D\u300D\u304C\u672A\u6765\u306B\u7E4B\u304C\u3063\u3066\u3044\u304D\u307E\u3059\u3002"]
    })
  }]
}, {
  talkTitle: 'トライアルらしさとは',
  talkList: [{
    id: '1',
    nameColor: '#002D65',
    name: '永田',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u6D41\u901A\u3092\u79D1\u5B66\u3059\u308B\u3053\u3068\u304C\u3001\u30D3\u30B8\u30E7\u30F3\u306B\u3042\u308B\u300C\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u300D\u3068\u3044\u3046\u8A00\u8449\u306B\u51DD\u7E2E\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u4ECA\u5F8C\u3001\u9577\u3044\u6642\u9593\u3092\u304B\u3051\u3066\u79C1\u305F\u3061\u304C\u9054\u6210\u3057\u3066\u3044\u304F\u3053\u3068\u3092\u3001\u30D1\u30FC\u30D1\u30B9\u3084\u30D3\u30B8\u30E7\u30F3\u3068\u3057\u307E\u3057\u305F\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u79C1\u305F\u3061\u306F\u30B0\u30ED\u30FC\u30D0\u30EB\u8996\u70B9\u3092\u6301\u3063\u3066\u304A\u308A\u3001\u300C\u4E16\u754C\u300D\u3084\u300C\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u300D\u3068\u3044\u3046\u5358\u8A9E\u3067\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u3089\u3057\u3055\u3092\u8868\u73FE\u3057\u3066\u3044\u304D\u307E\u3059\u3002"]
    })
  }, {
    id: '2',
    nameColor: '#3786c7',
    name: '石橋',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u4ECA\u3068\u672A\u6765\u306E\u4E21\u65B9\u3092\u540C\u6642\u306B\u52D5\u304B\u3057\u3066\u3044\u304F\u3053\u3068\u304C\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u3089\u3057\u3055\u306E\u4E00\u3064\u3067\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5E97\u8217\u3067\u7269\u3092\u6D41\u901A\u3055\u305B\u308B\u30EA\u30A2\u30EB\u3068\u3001\u30C7\u30FC\u30BF\u3068\u3044\u3046\u30D0\u30FC\u30C1\u30E3\u30EB\u3092\u540C\u6642\u306B\u52D5\u304B\u3057\u3066\u3044\u308B\u3053\u3068\u304C\u79C1\u305F\u3061\u3089\u3057\u3055\u3067\u3042\u308A\u3001\u305D\u308C\u3092\u30D0\u30EA\u30E5\u30FC\u306B\u8868\u73FE\u3057\u3066\u3044\u307E\u3059\u3002"]
    })
  }]
}];
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Company/CompanyLinks/index.tsx
var CompanyLinks = __webpack_require__(52143);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/Company/Philosophy/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var PhilosophyPage = function PhilosophyPage() {
  var explanationItemList = [{
    mainTitle: 'Purpose',
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "\u4E16\u754C\u306E\u8AB0\u3082\u304C\u300C\u8C4A\u304B\u3055\u300D\u3092\u4EAB\u53D7\u3067\u304D\u308B \u793E\u4F1A\u3092\u3064\u304F\u308B\u3002"
    })
  }, {
    mainTitle: 'Vision',
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3068\u3001\u4EBA\u306E\u7D4C\u9A13\u77E5\u3067\u3001 \u4E16\u754C\u306E\u30EA\u30A2\u30EB\u30B3\u30DE\u30FC\u30B9\u3092\u5909\u3048\u308B\u3002"
    })
  }, {
    mainTitle: 'Value',
    text: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\u30FB\u52B9\u7387\u5316\u3055\u308C\u305F\u5E97\u8217\u7DB2\u3067\u3001\u30E2\u30CE\u3092\u6D41\u901A\u3055\u305B\u308B\u529B"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\u30FB\u30C7\u30FC\u30BF\u3068IoT\u3092\u99C6\u4F7F\u3059\u308B\u529B"
      })]
    })
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u7D4C\u55B6\u7406\u5FF5",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u7D4C\u55B6\u7406\u5FF5\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        type: 'article',
        url: 'company/philosophy/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PhilosophyMainWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PhilosophyMain, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          titleText: "Philosophy",
          subTitleText: "\u7D4C\u55B6\u7406\u5FF5",
          color: "normal"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Philosophy, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: "\u5F53\u793E\u30B0\u30EB\u30FC\u30D7\u306E\u30D1\u30FC\u30D1\u30B9\u30FB\u30D3\u30B8\u30E7\u30F3\u30FB\u30D0\u30EA\u30E5\u30FC"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PhilosophyTriangle, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/images/Philosophy_JP.svg",
                alt: "TRIAL Holdings\u306E\u30D1\u30FC\u30D1\u30B9\u30FB\u30D3\u30B8\u30E7\u30F3\u30FB\u30D0\u30EA\u30E5\u30FC"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Explanation, {
              children: explanationItemList.map(function (_ref) {
                var mainTitle = _ref.mainTitle,
                    text = _ref.text;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(ExplanationItem, {
                  mainTitle: mainTitle,
                  text: text
                }, mainTitle);
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SpecialTalk, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
            children: ["Special Talk", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "\u30B9\u30DA\u30B7\u30E3\u30EB\u5BFE\u8AC7"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NameWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
              "data-left": true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "\u53D6\u7DE0\u5F79 \u77F3\u6A4B \u4EAE\u592A"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
              "data-right": true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "\u53D6\u7DE0\u5F79 \u6C38\u7530 \u6D0B\u5E78"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 60,
              pc: 70
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/images/philosophy-talk.webp",
            alt: "PhilosophyTalk\u753B\u50CF"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 34,
              pc: 60
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TalkMain, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TalkLead, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              children: "\u300C\u3089\u3057\u3055\u300D\u3092\u8FBC\u3081\u305F\u7B56\u5B9A\u79D8\u8A71"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "\u4F01\u696D\u7D4C\u55B6\u306B\u304A\u3044\u3066\u3001\u81EA\u793E\u306E\u5B58\u5728\u610F\u7FA9\u3092\u660E\u78BA\u306B\u3057\u306A\u304C\u3089\u3001\u793E\u4F1A\u306B\u4E0E\u3048\u308B\u4FA1\u5024\u3092\u793A\u3059\u300C\u30D1\u30FC\u30D1\u30B9\u300D\u304C\u6CE8\u76EE\u3092\u96C6\u3081\u3066\u3044\u307E\u3059\u3002\u3055\u3089\u306B\u3001\u81EA\u793E\u306E\u4FA1\u5024\u89B3\u3084\u76EE\u6307\u3059\u59FF\u3092\u300C\u30D3\u30B8\u30E7\u30F3\u300D\u3084\u300C\u30D0\u30EA\u30E5\u30FC\u300D\u3068\u3057\u3066\u8A00\u8A9E\u5316\u3059\u308B\u3053\u3068\u3067\u3001\u7D44\u7E54\u306E\u4E00\u4F53\u611F\u3092\u91B8\u6210\u3059\u308B\u5F79\u5272\u3092\u679C\u305F\u3057\u307E\u3059\u3002"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306B\u304A\u3051\u308B\u300C\u30D1\u30FC\u30D1\u30B9\u30FB\u30D3\u30B8\u30E7\u30F3\u30FB\u30D0\u30EA\u30E5\u30FC\u300D\u306F\u3001\u7D4C\u55B6\u9663\u304C\u8B70\u8AD6\u3092\u91CD\u306D\u306A\u304C\u3089\u3001\u305D\u308C\u305E\u308C\u306E\u71B1\u3044\u601D\u3044\u3092\u30AB\u30BF\u30C1\u306B\u3057\u305F\u3082\u306E\u3067\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u53D6\u7DE0\u5F79 \u77F3\u6A4B \u4EAE\u592A\u3001\u53D6\u7DE0\u5F79 \u6C38\u7530 \u6D0B\u5E78\u306B\u7B56\u5B9A\u79D8\u8A71\u3092\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC\u3057\u307E\u3057\u305F\u3002"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 56,
              pc: 110
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Talk, {
            children: [talkItemList.map(function (_ref2) {
              var talkTitle = _ref2.talkTitle,
                  talkList = _ref2.talkList;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(TalkList, {
                talkTitle: talkTitle,
                talkList: talkList
              }, talkTitle);
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                style: {
                  textAlign: 'right'
                },
                children: "2022\u5E7412\u6708"
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLinks/* CompanyLinks */.b, {
        padding: {
          pc: '130px 0 0'
        }
      })]
    })]
  });
};

PhilosophyPage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'Corporate Information',
    subTitle: '企業情報'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '企業情報',
    path: '/company/'
  }, {
    name: '経営理念',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: true,
    children: page
  }));
};

var PhilosophyMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__PhilosophyMainWrapper",
  componentId: "sc-11xhzn0-0"
})(["width:1040px;padding-bottom:130px;margin:0 auto 0;@media screen and (max-width:1047px){width:100%;margin:0 auto 0;padding:0 20px 70px;}"]);
var PhilosophyMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__PhilosophyMain",
  componentId: "sc-11xhzn0-1"
})(["margin-top:78px;@media screen and (max-width:1047px){margin-top:40px;}"]);
var Philosophy = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Philosophy",
  componentId: "sc-11xhzn0-2"
})(["margin-top:132px;background-color:", ";padding:70px;h3{color:", ";font-size:28px;font-weight:bold;text-align:center;line-height:1.2;}@media screen and (max-width:1047px){margin-top:70px;padding:40px 20px;h3{font-size:20px;}}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var PhilosophyTriangle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__PhilosophyTriangle",
  componentId: "sc-11xhzn0-3"
})(["margin-top:80px;display:flex;gap:80px;@media screen and (max-width:1047px){flex-direction:column;align-items:center;margin-top:40px;gap:40px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__ImageWrapper",
  componentId: "sc-11xhzn0-4"
})(["width:440px;height:340px;@media screen and (max-width:1047px){width:295px;height:228px;img{width:100%;height:100%;}}"]);
var Explanation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__Explanation",
  componentId: "sc-11xhzn0-5"
})([""]);
var SpecialTalk = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Philosophy__SpecialTalk",
  componentId: "sc-11xhzn0-6"
})(["margin-top:130px;h3{font-size:22px;color:#3786c7;line-height:32px;text-align:center;font-family:", ";}span{display:block;font-size:18px;line-height:1;color:", ";}img{width:100%;}@media screen and (max-width:1047px){margin-top:65px;h3{font-size:18px;}span{font-size:12px;}}"], theme/* theme.fontEn */.r.fontEn, theme/* theme.colors.textTitle */.r.colors.textTitle);
var NameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__NameWrapper",
  componentId: "sc-11xhzn0-7"
})(["margin-top:46px;display:flex;justify-content:center;gap:93px;@media screen and (max-width:1047px){flex-direction:column;align-items:center;gap:49px;}"]);
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__Name",
  componentId: "sc-11xhzn0-8"
})(["width:274px;height:64px;padding:17px 25px;position:relative;p{color:#fff;font-size:28px;line-height:1;}&[data-left]{background-color:#3786c7;&::after{content:'';width:0;height:0;border-style:solid;border-width:32px 0 32px 30px;border-color:transparent transparent transparent #3786c7;display:inline-block;position:absolute;right:-30px;top:0;}&::before{content:'';height:2px;width:90px;background-color:#3786c7;transform:rotate(45deg);display:inline-block;position:absolute;top:31px;right:-91px;}}&[data-right]{background-color:", ";&::after{content:'';width:0;height:0;border-style:solid;border-width:32px 30px 32px 0;border-color:transparent ", " transparent transparent;display:inline-block;position:absolute;left:-30px;top:0;}&::before{content:'';height:2px;width:90px;background-color:", ";transform:rotate(-45deg);display:inline-block;position:absolute;top:31px;left:-91px;}}@media screen and (max-width:1047px){height:50px;padding:13px 50px 12px;p{font-size:22px;}&[data-left]::after,&[data-right]::after{display:none;}&[data-left]::before{width:35px;top:85px;left:50%;transform:rotate(45deg) translateX(-50%);}&[data-right]::before{width:35px;top:-39px;left:50%;transform:rotate(-45deg) translateX(-50%);}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var TalkMain = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Philosophy__TalkMain",
  componentId: "sc-11xhzn0-9"
})([""]);
var TalkLead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__TalkLead",
  componentId: "sc-11xhzn0-10"
})(["h3{color:", ";font-size:28px;font-weight:bold;margin-bottom:40px;}p{font-size:18px;line-height:2;& + p{margin-top:30px;}}@media screen and (max-width:1047px){h3{font-size:20px;margin-bottom:20px;}p{font-size:15px;line-height:1.8;& + p{margin-top:20px;}}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var Talk = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__Talk",
  componentId: "sc-11xhzn0-11"
})([""]);
;// CONCATENATED MODULE: ./src/pages/company/philosophy.tsx


/***/ }),

/***/ 8326:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/philosophy",
      function () {
        return __webpack_require__(85132);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,9181,8517,5548,9774,2888,179], function() { return __webpack_exec__(8326); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);